import en from "../locales/en.json";
import es from "../locales/es.json";
import fr from "../locales/fr.json";
import de from "../locales/de.json";
import am from "../locales/am.json";

const translations = {
  EN: en,
  ES: es,
  FR: fr,
  DE: de,
  AM: am,
};

export const getTranslation = (lang) => {
  return translations[lang?.toUpperCase()] || translations.EN;
};